<template>
  <div class="modal-content">
    <div class="modal-header">
      <h3 class="modal-title" style="width: 100%">{{ _('Create reservation') }} <span class="pull-right"><i class="fa fa-fw fa-1x fa-cube"></i> {{ selectedResource.name }}</span></h3>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="well well-sm">
            {{ _('Creating direct resource reservations in only meant for internal purposes, such as blocking certain timeframes.') }}
            {{ _('For customer reservations, please use the Product reservations view.') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="start_ts">{{ _('Reservation starts') }}</label>
            <DatePicker v-model="dateStart" :max-date="dateEnd" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
            <TimePicker v-model="timeStart" :shortLocale="shortLocale"></TimePicker>
          </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="end_ts">{{ _('Reservation ends') }}</label>
            <DatePicker v-model="dateEnd" :min-date="dateStart" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
            <TimePicker v-model="timeEnd" :shortLocale="shortLocale"></TimePicker>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" id="participantSelectorContainer">
          <div class="form-group">
            <label for="reservationCount">{{ _('Capacity to be reserved') }}</label>
            <select class="form-control" id="reservationCount" v-model="participants">
              <option v-for="k in 100" :value="k">{{ k }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row" v-if="isFeatureEnabled('statisticsfinland')">
        <div class="col-md-12" id="maintenanceModeSelectorContainer">
          <div class="product-order-statistics form-group form-check">
            <input type="checkbox" id="maintenanceMode" v-model="maintenanceMode" class="form-check-input" />
            <label class="form-check-label" for="maintenanceMode">{{ _('Maintenance mode') }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="save"><i class="fa fa-fw fa-check"></i> {{ _('Create reservation') }}</button>
    </div>
  </div>
</template>

<script>

import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import { DatetimePicker } from '#components'
import settingshelpers from '~/lib/settingshelpers'

export default {
  data () {
    return {
      dateStart: null,
      dateEnd: null,
      timeStart: null,
      timeEnd: null,
      participants: 1,
      maintenanceMode: false
    }
  },
  props: ['event', 'selectedResource', 'shopId'],
  mixins: [settingshelpers],
  computed: {
    ...mapGetters(['locale', 'allSettings', 'dateFormat', 'timeFormat']),
    settings () {
      return this.shopSettings(this.shopId)
    },
    shortLocale () {
      return this.locale.split('_')[0]
    }
  },
  methods: {
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    },
    hideModal () {
      this.$emit('close')
    },
    save () {
      const data = {
        start: DateTime.fromJSDate(this.dateStart).set({
          hour: this.timeStart.hours,
          minute: this.timeStart.minutes
        }).toJSDate(),
        end: DateTime.fromJSDate(this.dateEnd).set({
          hour: this.timeEnd.hours,
          minute: this.timeEnd.minutes
        }).toJSDate(),
        participants: this.participants,
        resource: this.selectedResource,
        maintenanceMode: this.maintenanceMode
      }
      this.$emit('save', data)
    },
    inputDateStart(newValue) {
      this.dateStart = newValue
    },
    inputDateEnd(newValue) {
      this.dateEnd = newValue
    }
  },
  components: {
    DatetimePicker
  },
  created () {
    if (this.event && this.event.start_date && this.event.start_date instanceof Date) {
      this.dateStart = DateTime.fromJSDate(this.event.start_date).toJSDate()
      this.timeStart = {
        hours: DateTime.fromJSDate(this.event.start_date).hour,
        minutes: DateTime.fromJSDate(this.event.start_date).minute,
        seconds: 0
      }
    }
    if (this.event && this.event.end_date && this.event.end_date instanceof Date) {
      this.dateEnd = DateTime.fromJSDate(this.event.end_date).toJSDate()
      this.timeEnd = {
        hours: DateTime.fromJSDate(this.event.end_date).hour,
        minutes: DateTime.fromJSDate(this.event.end_date).minute,
        seconds: 0
      }
    }
  }
}
</script>